export function generateUsername(grid) {
  const cells = grid.flat().filter((c) => c.finalWord && c.finalWord !== '\u2014');
  const sorted = [...cells].sort((a, b) => (b.finalScore || 0) - (a.finalScore || 0));
  const words = sorted.slice(0, 3).map((c) => c.finalWord);
  if (words.length === 0) return 'Anonymous';
  const name = words.join('-');
  return name.length > 30 ? name.slice(0, 30) : name;
}
